export default __webpack_public_path__ + "static/media/S (26).4a4f48fe.png";